export const UserGroups = {
  SuperAdmin: "Super admin",
  TopManagement: "Top management",
  Manager: "Manager",
  Partner: "Partner",
  Investor: "Investor",
};

export const Permissions = {
  // startup permissions
  EXPORT_STARTUP: "export_startup",
  DELETE_STARTUP: "delete_startup",
  ADD_STARTUP: "add_startup",
  UPDATE_STARTUP: "update_startup",
  //   investor permissions
  EXPORT_INVESTOR: "export_investor",
  DELETE_INVESTOR: "delete_investor",
  ADD_INVESTOR: "add_investor",
  UPDATE_INVESTOR: "update_investor",
  //   report permissions
  ALL_REPORT_OPTIONS: "all_report_options",
};
